
import api from "../helpers/api"
class ReportService {

     /**
   * Fetches the activities report from backend
   * @param {Object} params - Filtering options
   * @param {String} params.start_date - Start date (YYYY-MM-DD)
   * @param {String} params.end_date - End date (YYYY-MM-DD)
   * @param {String} [params.period='weekly'] - 'weekly' or 'monthly'
   * @param {Number} [params.department_id] - Optional department filter
   * @returns {Promise<Object>} { data: [...], meta: {...} }
   */

  getActivityReport(params) {
    return api.get(`/reports/activities/weekly`, {
      params: {
        ...params,
        start_date: params.start_date,
        end_date: params.end_date,
        period: params.period || 'weekly',
        is_approved: true, 
        department_id: params.department_id || null,
      },
    });
  }

  async getUserKPI(userId,params) {
    try{
      const response =  await api.get(`/users/${userId}/kpi`, { params  });
      return response.data
    }catch(error){
      
      console.error('Error fetching user KPI:', error);
      throw error.response?.data || error; 
    }
  }

  async getUsersKPI(filters = {}) {

    const  response  = await api.get("/kpi/users", {
      params: {
        search: filters.search || null,
        sort_by: filters.sort_by || null,
        sort_order: filters.sort_order || null,
        range: filters.range || null, 
        is_approved: true,
      },
    });
    
    return response.data
  }

   async getDepartmentsKPI(filters) {
    try {
      const response = await api.get("/reports/departments-kpi", {
        params: {
          search: filters.search || "",
          sort_by: filters.sort_by || "average_performance",
          sort_order: filters.sort_order || "desc",
          range: filters.range || "30",
          is_approved: true,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching department KPI:", error);
      throw error;
    }
  }


  /**
   * (Optional) Download as CSV
   */
  downloadActivityReport(params) {

    //add is_approved param
    params.is_approved = true;
    return api.get(`/activities/export`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new ReportService();